import React from "react";
import actions from "../../../../store/actions";
import store from "../../../../store/store";
import ComponentChangeLogModalState from "./ComponentChangeLogModalState";
import stringHelper from "../../../../infrastructure/helpers/common/stringHelper";
import CustomIcon from "../../BootstrapIcons/Custom/CustomIcon";
import iconTooltip from "../../BootstrapIcons/Tooltip/IconTooltip";
import { ReactComponent as HistoryIcon } from '../../../Common/BootstrapIcons/history.svg';
import ComponentType from "../../../../types/report/ComponentType";

interface Props {
    componentType: string,
    componentName: string,
    reportConfigId: number;
    id?: number
}
class ComponentChangeLogIconAndAction extends React.Component<Props> {

    constructor(props: Props) {
        super(props);

        this.onViewChangeLogClick = this.onViewChangeLogClick.bind(this);
    }

    getType(){
        switch(this.props.componentType){
            case ComponentType.Case:return 'Case';
            case ComponentType.CaseField:return 'Enrichment';
            case ComponentType.MatchingKey:
            case ComponentType.MatchingKeyEndpoint:return 'System Keys';
            case ComponentType.AggregationField:return 'Aggregated Record Fields';
            case ComponentType.Aggregation:return 'Aggregation';
            case ComponentType.Variable:return 'Variable';
            case ComponentType.Lookup:return 'Lookup';
            case ComponentType.Variable:return 'Variable';
            case ComponentType.Filter:return 'Filters';
            case ComponentType.EndpointFilter:return 'Endpoint Filter';
            case ComponentType.OverReportFilter:return 'Over Report Filter';
            case ComponentType.UnderReportFilter:return 'Under Report Filter';
            case ComponentType.AccuracyValidation:return 'Validation';
            case ComponentType.Dictionary:return 'Dictionaries';
            case ComponentType.DictionaryField:return 'Dictionary Field';
            case ComponentType.DictionaryField:return 'Dictionary Field';
            case ComponentType.UserDefinedFunction:return 'User-Defined Functions';
            case ComponentType.UserDefinedFunctionParameter:return 'User-Defined Functions Parameter';
            
            default: return 'Cache Keys';
        }
    }

    onViewChangeLogClick(): void {
    
        var type = this.getType();

        let state: ComponentChangeLogModalState = {
            reportConfigId:this.props.reportConfigId,
            title: `Change Log for ${type}: ${this.props.componentName}`,
            isOpen: true,
            error: null,
            id: this.props.id || 0,
            componentType: this.props.componentType.replace(/\s+/g, '')
        };

        store.dispatch({ type: actions.componentChangeLogModal.open, payload: state });
    }

    render(): JSX.Element {

        return (
            <button className="custom-icon-button" onClick={() => this.onViewChangeLogClick()}>
                <CustomIcon icon={HistoryIcon} title={iconTooltip.changeLog} />
            </button>
        )
    }
}

export default ComponentChangeLogIconAndAction;
